import styled from 'styled-components'
import GoogleMaps from '../components/AssignmentsMapView/GoogleMaps'
import DateComponent from '../components/Common/DateComponent'

const MapViewPage = () => {
  return (
    <Wrapper>
      <DateComponent />
      <GoogleMaps />
    </Wrapper>
  )
}

export default MapViewPage

const Wrapper = styled.div`
  display: flex;
  gap: 30px;
  height: 100vh;
  width: 100%;
  padding: 2%;
  background-color: #fbfbfb;

  /* background-color: #123456; */
  box-sizing: border-box;
  overflow: hidden;
  flex-direction: column;
  /* align-items: center; */
`
